import React from "react";
import img1 from "../../assets/images/ft.jpg";
import img2 from "../../assets/images/bg.jpg";
import img3 from "../../assets/images/pt.jpg";
// =====================
// Single Mobile Screen Component (Dark Neon Theme)
// =====================
function MobileScreen({ screenContent, heightClass, widthClass, imageSrc }) {
  return (
    <div
      className={`relative rounded-[40px] overflow-hidden transform transition duration-500 hover:scale-[1.03] ${heightClass} ${widthClass}`}
      style={{
        background: "rgba(255,255,255,0.04)",
        backdropFilter: "blur(12px)",
        border: "1px solid rgba(0,245,160,0.25)",
        boxShadow: "0 0 25px rgba(0,245,160,0.15)",
      }}
    >
      {/* Top Notch */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-14 h-4 bg-black rounded-b-xl z-10" />

      {/* Screen Content or Image */}
      {imageSrc ? (
        <img
          src={imageSrc}
          alt="Mobile Screen"
          className="w-full h-full object-cover rounded-[40px]"
        />
      ) : (
        <div className="p-4 text-white overflow-y-auto h-full">{screenContent}</div>
      )}

      {/* Neon Overlay */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          boxShadow: "0 0 30px rgba(0,245,160,0.4)",
          border: "1px solid rgba(0,245,160,0.25)",
          borderRadius: "40px",
        }}
      />
    </div>
  );
}

// =====================
// Screen Content (Dark Mode)
// =====================
const getScreenContent = (type) => {
  switch (type) {
    case "explore":
      return (
        <div className="space-y-4">
          <div className="h-7 bg-white/10 rounded-full w-2/3 mt-4" />
          <h3 className="text-xl font-bold">Explore</h3>
          <div className="flex space-x-3">
            <div className="flex-1 h-36 bg-white/5 border border-white/10 rounded-xl" />
            <div className="flex-1 h-36 bg-gradient-to-br from-[#00CFFF]/30 to-[#00CFFF]/30 rounded-xl" />
          </div>
        </div>
      );
    case "detail":
      return (
        <div className="space-y-4">
          <div className="h-56 bg-white/10 rounded-b-xl -mx-4" />
          <p className="text-sm text-[#00F5A0] pt-2">NEW ARRIVAL</p>
          <div className="flex justify-between items-center">
            <span className="text-2xl font-bold">$18.00</span>
            <div className="text-yellow-400">★★★★★</div>
          </div>
          <div className="h-11 bg-gradient-to-r from-[#00F5A0] to-[#00CFFF] rounded-full mt-6 text-black flex items-center justify-center">
            + ADD TO CART
          </div>
        </div>
      );
    case "cart":
      return (
        <div className="space-y-4">
          <h3 className="text-xl font-bold mt-4">Cart (3 Items)</h3>
          <div className="space-y-3">
            {[1, 2, 3].map((i) => (
              <div key={i} className="h-16 bg-white/5 border border-white/10 rounded-xl" />
            ))}
          </div>
          <div className="pt-6 space-y-2 text-sm">
            <div className="flex justify-between text-white/70">
              <span>Subtotal:</span>
              <span>$240.00</span>
            </div>
            <div className="flex justify-between text-white/70">
              <span>Shipping:</span>
              <span>$10.00</span>
            </div>
            <div className="flex justify-between font-bold">
              <span>Total:</span>
              <span>$250.00</span>
            </div>
          </div>
          <div className="h-11 bg-gradient-to-r from-[#00F5A0] to-[#00CFFF] rounded-xl mt-6 text-black font-semibold flex items-center justify-center">
            Checkout
          </div>
        </div>
      );
    default:
      return null;
  }
};

// =====================
// Main Component
// =====================
export default function MobileAppUI() {
  const gradientText = {
    background: "linear-gradient(90deg, #00F5A0, #00CFFF)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  };

  // Example images


  return (
    <section className="py-20 px-6 lg:px-20 text-white relative bg-[#0B0E11]">
      {/* Heading – Mobile */}
      <h2
        className="text-4xl font-extrabold mb-10 text-center lg:hidden"
        style={gradientText}
      >
        MOBILE APP
      </h2>

      {/* Heading – Desktop Vertical */}
      <h2
        className="hidden lg:block absolute top-2/3 left-0 -translate-y-1/2 text-6xl font-extrabold tracking-wide"
        style={{
          ...gradientText,
          transform: "rotate(-90deg) translateY(50%)",
          transformOrigin: "left center",
        }}
      >
        MOBILE APP
      </h2>

      {/* Screens Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        <div className="flex flex-col gap-8">
          <MobileScreen imageSrc={img1} heightClass="h-[520px]" widthClass="w-[270px]" />
        </div>
        <div className="flex flex-col gap-8">
          <MobileScreen imageSrc={img2} heightClass="h-[600px]" widthClass="w-[280px]" />
        </div>
        <div className="flex flex-col gap-8">
          <MobileScreen imageSrc={img3} heightClass="h-[520px]" widthClass="w-[270px]" />
        </div>
      </div>

      {/* Footer Text */}
      <p className="mt-14 text-center text-white/70 max-w-3xl mx-auto">
        We build futuristic mobile apps with stunning UI, smooth UX, and
        performance-driven architecture — designed to scale your business.
      </p>

      {/* CTA */}
      <div className="mt-6 text-center">
        <button className="font-semibold text-[#00F5A0] hover:underline">
          Show More
        </button>
      </div>
    </section>
  );
}
